// export const RootPath = '/home/bowei/Dropbox/Castp4.0/Webpage/futurecast-front/build/'
export const RootPath = '/castpfold/'


// WEBPACK FOOTER //
// ./src/Settings.js